document.addEventListener('DOMContentLoaded', function () {
  // Hover menu desktop
  document.querySelectorAll('.hover-menu-kom').forEach(function (element) {
    element.addEventListener('click', function () {
      var link = this.getAttribute('data-link');
      if (link) {
        window.location.href = link;
      }
    });
    element.addEventListener('mouseover', function () {
      this.setAttribute('open', '');
      this.classList.add('is-open');
    });

    element.addEventListener('mouseout', function () {
      this.removeAttribute('open');
      this.classList.remove('is-open');
    });
  });
  setTimeout(function () {
    // Seleziona tutte le ancore all'interno del widget
    var anchors = document.querySelectorAll('.feedaty_widget.recensioni_con_ancora a');
    anchors.forEach(function (anchor) {
      anchor.removeAttribute('href');
    });
  }, 2000);


  // script menu secondo livello
  document.addEventListener('click', function (event) {
    // Apertura: tap ovunque sulla freccia o sulla sua icona (svg/path)
    var apri = event.target.closest ? event.target.closest('.kom-apertura-menu') : null;
    if (apri) {
      event.preventDefault();
      var closestMenu = apri.closest('.kom-menu-lv2');
      if (closestMenu) {
        closestMenu.classList.add('kom-is-open');
      }
      return;
    }
    // Chiusura: tap ovunque sul bottone di chiusura o sulla sua icona/testo
    var chiudi = event.target.closest ? event.target.closest('.kom-chiusura-menu') : null;
    if (chiudi) {
      event.preventDefault();
      var closestMenu = chiudi.closest('.kom-menu-lv2');
      if (closestMenu) {
        closestMenu.classList.remove('kom-is-open');
      }
    }
  }, { capture: true });

});